document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.image-slideshow .swiper').forEach(function (slider) {
        const autoRotate = slider.dataset.autoRotate === 'true';
        const slidesSpeed = Number(slider.dataset.slidesSpeed) * 1000;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            speed: 1000,
            autoplay: autoRotate ? {
                delay: slidesSpeed,
                disableOnInteraction: false
            } : false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
        });
    });
    
});